import { DiscountPayloadType } from 'corporate/enums';
import {
  getPricingProfileCriteria,
  getPricingProfileRuleType,
} from 'pricing/components/UpsertPricingProfileRule/utils';
import { IUpsertPricingProfileCostingCalculationPayload } from 'pricing/types';

import { IPricingProfileCostingCalculationForm } from './types';

export const mapUpsertPricingProfileCostingCalculation = (
  structureId: number,
  data: IPricingProfileCostingCalculationForm,
  costingCalculationId?: number
): IUpsertPricingProfileCostingCalculationPayload => {
  return {
    ...(costingCalculationId && { id: costingCalculationId }),
    manufacturerId: data.manufacturer?.id,
    categoryId: data.category?.id,
    structureId,
    discount: data.value,
    applyTo: data.applyTo,
    type: getPricingProfileRuleType(data, DiscountPayloadType.COST_DISCOUNT),
    ...getPricingProfileCriteria(data),
  };
};
